/* eslint-disable react/prop-types */
import React, { useMemo, useState } from "react";
import { Menu, MenuItem, Checkbox, ListItemText } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useDispatch, useSelector } from "react-redux";
import { tableSelector } from "store/slices/tableSlice";
import { setOrderedColumns, setSomaticOrderedColumns } from "store/slices/tableSlice";

export const ColumnList = ({ columnNamespace = "main" }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const { orderedColumns, somaticOrderedColumns } = useSelector(tableSelector);
  const activeColumns = columnNamespace === "somatic" ? somaticOrderedColumns : orderedColumns;
  const setActiveColumns =
    columnNamespace === "somatic" ? setSomaticOrderedColumns : setOrderedColumns;
  const dispatch = useDispatch();

  const handleOpenMenu = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const handleColumnToggle = (column) => {
    const orderedColumnClone = structuredClone(activeColumns);
    const columnToToggle = orderedColumnClone.find(
      (col) => col.Header.toLowerCase() === column.Header.toLowerCase()
    );
    if (columnToToggle) {
      columnToToggle.isHidden = !column.isHidden;
    }
    dispatch(setActiveColumns(orderedColumnClone));
  };

  const columns = useMemo(() => activeColumns, [activeColumns]);

  return (
    <>
      <MDBox>
        <MDButton variant="gradient" color="info" onClick={handleOpenMenu} fullWidth>
          Columns
        </MDButton>
      </MDBox>
      <Menu id="column-menu" anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleCloseMenu}>
        {columns.map((column) => (
          <MenuItem key={column.Header} onClick={() => handleColumnToggle(column)}>
            <Checkbox style={{ padding: "0 5px" }} checked={!column.isHidden} />
            <ListItemText primaryTypographyProps={{ fontSize: "12px" }} primary={column.Header} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
